import { useState } from 'react'
import { useCurrentUser } from '~/lib/auth/use-current-user'
import { useDashboardChannel } from '~/lib/socket/use-dashboard-channel'
import { HolidayBanner } from '~/components/holiday-banner'
import { Column } from './column'
import { ErrorBanner } from './error-banner'
import { SkeletonSnapshot } from './skeleton'
import { SummaryBar } from './summary-bar'
import { useInvalidateSnapshot, useSnapshotToday } from './use-snapshot'
import styles from './today-page.module.scss'

export function TodayPage() {
  const [expanded, setExpanded] = useState<string | null>(null)
  const { data, isLoading, isFetching, isError } = useSnapshotToday()
  const { data: me } = useCurrentUser()
  const invalidate = useInvalidateSnapshot()

  useDashboardChannel(me?.socket_token ?? null, () => {
    invalidate()
  })

  function toggle(slackId: string) {
    setExpanded(cur => (cur === slackId ? null : slackId))
  }

  if (isLoading || !data) {
    return <SkeletonSnapshot />
  }

  return (
    <div className={styles.page}>
      {isError && <ErrorBanner />}

      <SummaryBar snapshot={data} isFetching={isFetching} />

      {data.company_holiday ? (
        <HolidayBanner holiday={data.company_holiday} outEntries={data.out} />
      ) : (
        <div className={styles.grid}>
          <Column
            title="Working today"
            entries={data.working}
            emptyText="Nobody's checked in yet."
            expandedSlackId={expanded}
            onToggle={toggle}
          />
          <Column
            title="Out today"
            entries={data.out}
            emptyText="Everyone's around."
            expandedSlackId={expanded}
            onToggle={toggle}
          />
          <Column
            title="Missing"
            entries={data.missing}
            emptyText="No outstanding check-ins."
            expandedSlackId={expanded}
            onToggle={toggle}
          />
        </div>
      )}
    </div>
  )
}
